import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AuthService } from '../auth.service';
import { ResponseModel } from '@models/response.model';
import { RoleModel } from '@models/role.model';
import { PermissionModel } from '@shared/models/permission.model';
import { Subject } from 'rxjs';
import { getCurrentContextIds } from '@shared/utils/current-context.util';

@Injectable({ providedIn: 'root' })
export class RoleService {
  update = new Subject();
  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {}

  getAll(filterKeyword: string | null = null) {
    const { restaurantId, branchId } = getCurrentContextIds();
    let params = new HttpParams();
    if (filterKeyword !== null) {
      params = params.set('filter[name]', filterKeyword);
    }
    return this.http.get<ResponseModel<RoleModel[]>>(`restaurants/${restaurantId}/branches/${branchId}/roles/show-all`, { params });
  }

  addRole(role) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<RoleModel>>(`restaurants/${restaurantId}/branches/${branchId}/roles/add-role`, role);
  }

  updateRole(id: string, role) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.put<ResponseModel<RoleModel>>(`restaurants/${restaurantId}/branches/${branchId}/roles/${id}/edit-role`, role);
  }

  deleteRole(id: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.delete(`restaurants/${restaurantId}/branches/${branchId}/roles/${id}`);
  }

  getRolesPermission(roleId: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<PermissionModel[]>>(`restaurants/${restaurantId}/branches/${branchId}/roles/${roleId}/show-permissions`);
  }

  updateRolePermissions(id: string, permissions: { permissionIds: string[] }) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<RoleModel>>(`restaurants/${restaurantId}/branches/${branchId}/roles/${id}/add-permissions`, permissions);
  }

  sendUpdate(message: string) {
    this.update.next(message);
  }

  getUpdate() {
    return this.update.asObservable();
  }

  // editUserRole(id: string, roles: RoleModel[]) {
  //   return this.http.post<ResponseModel<UserModel>>(`admin/users/${id}/roles`, roles).pipe(
  //     tap(async response => {
  //       const tokenModel: TokenModel = new BehaviorSubject<TokenModel>(
  //         JSON.parse(localStorage.getItem(StorageKeysEnum.USER)!)
  //       ).value as TokenModel;

  //       if (tokenModel !== null && response.data != null) {
  //         if (tokenModel.profile.id === response.data.id) {
  //           this.authService.handleAuthenticationAfterEditRoles(response.data);
  //         }
  //       }
  //     })
  //   );
  // }
}
